import { useDroppable } from '@dnd-kit/core';

interface DroppableCategoryAreaProps {
  id: string;
  children: React.ReactNode;
  isEmpty: boolean;
}

export default function DroppableCategoryArea({ id, children, isEmpty }: DroppableCategoryAreaProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`border-t border-gray-100 transition-colors duration-200 ${
        isOver
          ? 'bg-teal-50/80 border-teal-300 border-2 rounded-b-xl'
          : ''
      }`}
    >
      {isEmpty ? (
        <div className={`p-6 text-center transition-colors duration-200 ${isOver ? 'bg-teal-100/50' : ''}`}>
          <p className={`text-sm ${isOver ? 'text-teal-600 font-medium' : 'text-gray-400'}`}>
            {isOver ? 'Déposer ici pour déplacer' : 'Déposez une analyse ici'}
          </p>
        </div>
      ) : (
        children
      )}
    </div>
  );
}